<template>
    <div class="description-section">
        <div class="container p-l-30 p-r-30">
            <div class="row">
                <div class="col-lg-5 col-md-12">
                    <div class="description-img mb-5 mb-lg-0">
                        <img class="img-fluid" src="@/assets/images/launch-page/event-section.svg" alt="">
                    </div>
                </div>
                <div class="col-lg-7 col-md-12">
                    <div class="description-text pl-0 pl-lg-5">
                        <ul class="font-30">
                            <li>
                                <p>Engage your community.</p>
                            </li>
                            <li>
                                <p>Easily post and manage your online or in-person events on a trusted platform and build a
                                    seamless attendee experience that elevates your brand.</p>
                            </li>
                            <li>
                                <p>Empowers you to create events to engage and encourage collaborations within your
                                    community.</p>
                            </li>
                            <li>
                                <p>Easily set up and sell tickets to virtual and in-person events—all in one place.</p>
                            </li>
                            <li>
                                <p>Flexible event payouts.</p>
                            </li>
                            <li>
                                <p>Set up payouts for your events on a custom schedule of your choice and get paid quickly.
                                </p>
                            </li>
                        <li>
                            <p>Customize your attendee registration form - Collect the information you need from the
                                attendees you need it from.</p>
                        </li>
                        <li>
                            <p>Utilize discount codes.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div></template>
<script>
export default {
    name: "EventDescription"
}
</script>